import type { PreparationStage } from '../../types';

interface Props {
  stage: PreparationStage;
}

export default function StageIcon({ stage }: Props) {
  const path = stagePath(stage);

  return (
    <svg
      aria-hidden="true"
      className="h-5 w-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      {path}
    </svg>
  );
}

function stagePath(stage: PreparationStage) {
  switch (stage) {
    case 'not_started': {
      return <path strokeLinecap="round" strokeLinejoin="round" d="M6 4.5h9l3 3V19.5H6zM15 4.5v3h3M9 12h6M9 15h4" />;
    }
    case 'form_filed': {
      return <path strokeLinecap="round" strokeLinejoin="round" d="M5 8.5h14M7 5.5h10l2 3v10H5v-10zM8 12h8M8 15h5" />;
    }
    case 'fee_paid': {
      return <path strokeLinecap="round" strokeLinejoin="round" d="M4 7.5h16v11H4zM4 10.5h16M8 15h3" />;
    }
    case 'portal_ready': {
      return <path strokeLinecap="round" strokeLinejoin="round" d="M12 3.5l2.2 5.2 5.3.5-4 3.5 1.2 5.2-4.7-2.8-4.7 2.8 1.2-5.2-4-3.5 5.3-.5z" />;
    }
  }
}
